
const config = {
    tg_api_call: "https://api.telegram.org/bot1705339041:AAF4BIvFFyrSL4xoP28PPbgd6wtodbLrYgU/getChatMembersCount?chat_id=-1001345524261",
    bot_token: "1705339041:AAF4BIvFFyrSL4xoP28PPbgd6wtodbLrYgU"
}

export default config;